import { Tooltip, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import {
  HEALTH_LABEL,
  HEALTH_TOKEN,
  HEALTH_TOOLTIP,
  healthOf,
} from "./connectorHealth";
import { Selection } from "./types";

/**
 * Whether this competitor's prices are arriving, in the client's terms.
 *
 * Shared by the map's selected list and the history tab's competitor tiles, so the
 * two say the same thing in the same shape — it lived inside `SelectedList` until
 * the second caller appeared.
 *
 * ⚠️ `caption` in a palette colour with no chip background, the same shape
 * `Sweep/Connectors/ConnectorStatusLabel` and `Connectivity/ActivityLog/StatusChip` use. A filled
 * chip per row turns a short list into a column of colour blocks and competes with
 * the competitor's name, which is what the reader is actually scanning for.
 *
 * ⚠️ `sx={{ color }}`, never `color=`: on this MUI version `Typography`'s `color`
 * prop is not a system prop, so a palette path is emitted as a raw CSS value and
 * silently ignored — no error, just the default colour.
 */
export const PricingState = ({ item }: { item: Selection }) => {
  const health = healthOf(item);
  return (
    <Tooltip title={<FormattedMessage id={HEALTH_TOOLTIP[health]} />}>
      <Typography
        variant="caption"
        sx={{ color: HEALTH_TOKEN[health], fontWeight: 600 }}
      >
        <FormattedMessage id={HEALTH_LABEL[health]} />
      </Typography>
    </Tooltip>
  );
};

export default PricingState;
